import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Container,
  Stack,
} from "@mui/material";
import DonateButton from "./DonateButton"; // Ensure this path is correct
import { motion, AnimatePresence } from "framer-motion";

const headlines = [
  {
    subtitle: "Healthy Mothers. Healthy Futures.",
    title: "Communities leading the change for safer births.",
    date: "",
    description:
      "We're placing communities at the center of solutions to reduce maternal mortality, strengthen health systems and redefine how Kenya protects mothers and newborns",
    img_url:
      "https://file.fountainafrica.org/wp-content/uploads/2020/01/2-768x420.jpg",
  },
  {
    subtitle: "Empowered Communities. Safer Births.",
    title: "Training hands that deliver life.",
    description:
      "We're working with local health systems to expand emergency obstetric care, train skilled birth attendants and ensure every mother has access to life-saving services.",
    date: "",
    img_url: "https://picsum.photos/400/250?random=1",
  },
  {
    subtitle: "Closing the Gap. Saving Lives.",
    title: "Turning gaps into solutions, one facility at a time.",
    date: "",
    description:
      "We're addressing regional disparities in maternal care by empowering underserved communities with resources, knowledge and access to quality health services.",
    img_url: "https://picsum.photos/400/250?random=2",
  },
  {
    subtitle: "Building Health Systems That Work",
    title: "Coverage that protects, not excludes.",
    date: "",
    description:
      "We're supporting Kenya's transition to universal health coverage while ensuring no mother loses access to free, quality maternity care.",
    img_url: "https://picsum.photos/400/250?random=2",
  },
];

export default function HeroSectionTwo() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % headlines.length);
    }, 5000); // change every 5 seconds
    return () => clearInterval(timer);
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        // Using minHeight prevents content clipping on very small screens if text is long
        minHeight: "90vh", 
        height: "auto",
        backgroundImage: `url('${
          headlines[index]?.img_url
            ? headlines[index].img_url
            : "https://fountainafrica.org/wp-content/uploads/2020/01/2-768x420.jpg"
        }')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        textAlign: "left",
        overflow: "hidden", // Prevents scrollbars during animation
      }}
    >
      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "rgba(0, 0, 0, 0.55)",
        }}
      />

      <Container
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          // RESPONSIVE LAYOUT LOGIC HERE:
          // 'column' for mobile (xs), 'row' for desktop (md)
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center", 
          justifyContent: "center",
          gap: { xs: 4, md: 8 }, // Adds space between the top/bottom or left/right
          py: { xs: 8, md: 0 }, // Add vertical padding on mobile
        }}
      >
        {/* --- LEFT SIDE (Top on Mobile) --- */}
        <Stack
          spacing={2}
          // RESPONSIVE WIDTH:
          sx={{ 
            width: { xs: "100%", md: "50%" },
            maxWidth: { xs: "100%", md: "50%" } 
          }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={headlines[index].title}
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -50, opacity: 0 }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  textTransform: "uppercase",
                  color: "#c18078",
                  letterSpacing: 1,
                  fontWeight: 700,
                  mb: 1,
                }}
              >
                {headlines[index].subtitle}
              </Typography>

              <Typography
                variant="h2"
                sx={{
                  fontWeight: 800,
                  lineHeight: 1.1,
                  // Responsive font size for better mobile experience
                  fontSize: { xs: "2.5rem", md: "3.75rem" }, 
                }}
              >
                {headlines[index].title}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "#ddd",
                  fontStyle: "italic",
                  mt: 1,
                }}
              >
                {headlines[index].date}
              </Typography>
            </motion.div>
          </AnimatePresence>
        </Stack>

        {/* --- RIGHT SIDE (Bottom on Mobile) --- */}
        <Stack
          spacing={2}
          display={"flex"}
          // RESPONSIVE ALIGNMENT & WIDTH:
          justifyContent={{ xs: "flex-start", md: "center" }}
          alignItems={{ xs: "flex-start", md: "center" }} // Left align on mobile, center on desktop? Or keep center?
          sx={{ 
            width: { xs: "100%", md: "50%" },
            maxWidth: { xs: "100%", md: "50%" } 
          }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={headlines[index].description}
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -30, opacity: 0 }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
            >
              <Typography
                variant="body1"
                sx={{
                  color: "#e0e0e0",
                  lineHeight: 1.5,
                  mb: 2,
                  fontSize: { xs: "1rem", md: "1.125rem" },
                }}
              >
                {headlines[index].description}
              </Typography>
              <DonateButton />
            </motion.div>
          </AnimatePresence>
        </Stack>
      </Container>
    </Box>
  );
}